export default "__VITE_ASSET__DkMp3AeK__"